import { InboxPreview } from 'Automations/components'
import { AutomationExecutionSummary } from 'Automations/watchtower/executionSummary'
import { useSelectedManualTask } from '../../../hooks/useSelectedManualTask'
import { ErrorBoundary } from 'common/components/ErrorBoundary/ErrorBoundary'
import PageError from 'components/ErrorPages/PageError'
import { CustomerInfoReviewPreview } from 'Automations/watchtower/inbox/manualTasks/definitions/customerInfoReview/components/previewContent/CustomerInfoReviewPreview'
import { CUSTOMER_INFO_REVIEW_TYPE } from 'Automations/watchtower/inbox/manualTasks/definitions/customerInfoReview/constants'
import { InvoiceUpdateReviewPreview } from 'Automations/watchtower/inbox/manualTasks/definitions/invoiceUpdateReview/components/previewContent/InvoiceUpdateReviewPreview'
import { INVOICE_UPDATE_REVIEW_TYPE } from 'Automations/watchtower/inbox/manualTasks/definitions/invoiceUpdateReview/constants'

export const ManualTaskPreview = () => {
  const { selectedManualTask, isPending, automationExecutionId } =
    useSelectedManualTask()

  if (isPending) {
    return <InboxPreview.LoadingState />
  }

  if (!selectedManualTask) {
    return <InboxPreview.EmptyState />
  }

  // Customer-info review tasks aren't backed by an automation execution, so this
  // must be checked before the `automationExecutionId` guard below — real tasks
  // of this type have no execution id and would otherwise fall through to the
  // empty state. They render their own activity/details pane.
  if (selectedManualTask.type === CUSTOMER_INFO_REVIEW_TYPE) {
    return (
      <ErrorBoundary
        name="ManualTaskPreview.customerInfoReview"
        fallback={<PageError />}
      >
        <CustomerInfoReviewPreview taskId={selectedManualTask.id} />
      </ErrorBoundary>
    )
  }

  // Invoice-update review tasks aren't backed by an automation execution either,
  // so they're routed here — before the `automationExecutionId` guard — to their
  // own activity/details pane.
  if (selectedManualTask.type === INVOICE_UPDATE_REVIEW_TYPE) {
    return (
      <ErrorBoundary
        name="ManualTaskPreview.invoiceUpdateReview"
        fallback={<PageError />}
      >
        <InvoiceUpdateReviewPreview taskId={selectedManualTask.id} />
      </ErrorBoundary>
    )
  }

  if (!automationExecutionId) {
    return <InboxPreview.EmptyState />
  }

  return (
    <ErrorBoundary name="ManualTaskPreview" fallback={<PageError />}>
      <AutomationExecutionSummary
        automationExecutionId={automationExecutionId}
      />
    </ErrorBoundary>
  )
}
